import React from 'react';
import API from '../../Services/API';

const Text = ({children, text, rich}) => {
    if (rich) {
        const substituted = rich.replace('{{$businessId}}', API.jwt('businessId'))

        // Test for any HTML and output it as such
        if (/<\/?[a-z][\s\S]*>/i.test(substituted)) {
            return <div dangerouslySetInnerHTML={{ __html: substituted }} />
        } else {
            // Or add <p> and <br /> as needed
            return substituted.split("\n\n").map((para, i) => {
                return <p key={'para' + i}>{
                    para.split("\n").map((l, x) => {
                        const text = l.replace(/\*\*(.+)\*\*/, '<strong>$1</strong>')
                            .replace(/\*(.+)\*/, '<em>$1</em>');
                        return <span key={'br' + x} dangerouslySetInnerHTML={{ __html: text + '<br />' }} />
                    })
                }</p>
            })
        }
    }

    if (text && typeof text === 'string') {
        return text.split('\n').map((item, key)  => <span key={key}>{item}<br /></span>)
    } else if (text) {
        return text;
    }

    if (typeof children === 'string') {
        return children.split('\n').map((item, key)  => <span key={key}>{item}<br /></span>)
    } else if (children) {
        return children;
    }

    return null;
}

export default Text;
